import styled from 'styled-components';

export const NumberInputWithHashStyles = styled.div`
	.input {
		svg {
			color: ${({ theme }) => theme.v3.colors.gray[9]};
		}
	}
`;
